import React from 'react';
import Top3RewardsApproval from '../../../components/admin/gamification/Top3RewardsApproval';

/**
 * GamificationRewardsPage - Página de gestión de recompensas para ADMIN
 * Incluye aprobación de recompensas Top 3 y otros tipos de recompensas
 */
function GamificationRewardsPage() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-7xl">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
          Gestión de Recompensas
        </h1>
        <p className="text-gray-600 text-lg">
          Administra las recompensas de gamificación del sistema
        </p>
      </div>

      {/* Panel de aprobación de recompensas Top 3 */}
      <div className="mb-8">
        <Top3RewardsApproval />
      </div>

      {/* Aquí se pueden agregar más secciones en el futuro:
          - Historial de recompensas aprobadas/rechazadas
          - Estadísticas de recompensas
          - Configuración de recompensas
      */}
    </div>
  );
}

export default GamificationRewardsPage;
